import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  InsightSettingsData,
  MedItem,
} from '../../lib/responses/getInsightSettings';

export interface InsightSettingsState {
  insightSettings: InsightSettingsData;
  meds: MedItem[];
  message: string | null;
  isLoading: boolean;
  isUpdating: boolean;
}

const initialState: InsightSettingsState = {
  insightSettings: {},
  meds: [],
  message: null,
  isLoading: false,
  isUpdating: false,
};

export const insightSettingsSlice = createSlice({
  name: 'insightSettings',
  initialState,
  reducers: {
    startLoadingInsightSettings: (state) => {
      state.isLoading = true;
    },
    endLoadingInsightSettings: (state) => {
      state.isLoading = false;
    },
    startUpdatingInsightSettings: (state) => {
      state.isUpdating = true;
    },
    endUpdatingInsightSettings: (state) => {
      state.isUpdating = false;
    },
    setInsightSettings: (
      state,
      {
        payload,
      }: PayloadAction<{
        insightSettings: InsightSettingsData;
        message: string;
      }>,
    ) => {
      state.insightSettings = payload.insightSettings;
      state.isLoading = false;
      state.message = payload.message;
    },
    setUpdateInsightSettings: (
      state,
      { payload }: PayloadAction<{ message: string | null }>,
    ) => {
      state.message = payload.message ?? null;
    },
    setMeds: (state, { payload }: PayloadAction<{ meds: MedItem[] }>) => {
      // filter out duplicates by mpp_id
      state.meds = payload.meds.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.mpp_id === value.mpp_id),
      );
    },
  },
});

export const {
  startLoadingInsightSettings,
  setInsightSettings,
  setUpdateInsightSettings,
  setMeds,
  endLoadingInsightSettings,
  startUpdatingInsightSettings,
  endUpdatingInsightSettings,
} = insightSettingsSlice.actions;
